<div fxLayout="row wrap">
    <div fxFlex.gt-sm="100" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <!-- <mat-card-title>Map</mat-card-title> -->
                 <form [formGroup]="formAttendance" (ngSubmit)="onSubmit()">
                    <div fxLayout="row wrap">
                        <div  fxFlex.gt-sm="33.33" fxFlex="100" class="p-10">
                            <mat-form-field style="margin-top: 15px;">
                                <mat-select placeholder="Emp Code" formControlName="code">
                                    <mat-option value="All">All</mat-option>
                                    <mat-option *ngFor="let empCode of codes" [value]="empCode.code">{{ empCode.code}}-{{empCode.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div  fxFlex.gt-sm="33.33" fxFlex="100" class="p-10">
                            <mat-form-field class="m-t-15">
                                <mat-label>From Date</mat-label>
                                <input [max]="maxDate" matInput [matDatepicker]="customdp1" formControlName="from_date">
                                <mat-datepicker-toggle matSuffix [for]="customdp1"></mat-datepicker-toggle>
                                <mat-datepicker #customdp1></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div  fxFlex.gt-sm="33.33" fxFlex="100" class="p-10">
                            <mat-form-field class="m-t-15">
                                <mat-label>To Date</mat-label>
                                <input [max]="maxDate" matInput [matDatepicker]="customdp2" formControlName="to_date">
                                <mat-datepicker-toggle matSuffix [for]="customdp2"></mat-datepicker-toggle>
                                <mat-datepicker #customdp2></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="margin-bottom: 10px; margin-left: 10px;">
                            <button mat-raised-button color="primary" type="submit" [disabled]="!formAttendance.valid">Search</button>
                        </div>
                    </div>
                </form> 
               
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div fxLayout="row wrap">
  <div fxFlex.gt-sm="100" fxFlex="100">
      <mat-card>
          <mat-card-content>
              <!-- <mat-card-title>Map</mat-card-title> -->
              
              <div class="table-responsive">
                <div>
                  <button mat-raised-button color="warn" (click)="exportExcel()">Export as Excel</button>
                </div>
                  <table mat-table [dataSource]="dataSource" class="table employee-list no-wrap">
        
                    <ng-container matColumnDef="#">
                      <th mat-header-cell *matHeaderCellDef> Name </th>
                      <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="employeecode">
                      <th mat-header-cell *matHeaderCellDef> Employee Code </th>
                      <td mat-cell *matCellDef="let element">
                        <div class="d-flex">
                         
                          <div class="m-l-15">
                            <p class="font-bold m-b-0 m-t-0">{{ element.EmpCode }}</p>
                          
                          </div>
                        </div>
                      </td>
                    </ng-container>
        
                    <ng-container matColumnDef="date">
                      <th mat-header-cell *matHeaderCellDef> Date </th>
                      <td mat-cell *matCellDef="let element"> {{element.att_date | date: 'dd/MM/yyyy'}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="in-time">
                      <th mat-header-cell *matHeaderCellDef> Check In </th>
                      <td mat-cell *matCellDef="let element"> {{element.CheckIn}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="out-time">
                      <th mat-header-cell *matHeaderCellDef>Check Out</th>
                      <td mat-cell *matCellDef="let element"> {{element.CheckOut}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="tot-working">
                      <th mat-header-cell *matHeaderCellDef> Location </th>
                      <td mat-cell *matCellDef="let element"> <a (click)="openDialog(element)" class="m-r-10 cursor-pointer"><i class="fa fa-eye"></i></a></td>
                    </ng-container>
        

        
                    <!-- <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef> Action </th>
                      <td mat-cell *matCellDef="let element" class="action-link">
                        <a (click)="openDialog('Update',element)" class="m-r-10 cursor-pointer"><i class="fa fa-pencil"></i></a>
                        <a (click)="openDialog('Delete',element)" class="m-r-10 cursor-pointer">
                          <i class="fa fa-trash text-danger"></i>
                        </a>
                      </td>
                    </ng-container> -->
        
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                      <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center;">
                        No data matching the filter.
                      </td>
                    </tr>
                  </table>
                  <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
                  
                </div>
          </mat-card-content>
      </mat-card>
  </div>
</div>
